import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntProcessSwitchComponent} from "./int-process-switch.component";
import {IntSpinLoaderModule} from "../../int-loader";

@NgModule({
  imports: [
    CommonModule,
    IntSpinLoaderModule
  ],
  declarations: [
    IntProcessSwitchComponent
  ],
  exports: [
    IntProcessSwitchComponent
  ]
})
export class IntProcessSwitchModule {}
